module.exports = __webpack_public_path__ + "static/media/new-docker.94a63db4.svg";